import React from 'react';
import ReactDOM from 'react-dom';

const render = (Component, store, history) => {
  ReactDOM.render(
    <Component store={store} history={history} />,
    document.getElementById('app'),
  );
};

export default render;
